import { BaseQuantity } from "../../interface/functionalityInterface";
// Base quantity
// coherent SI unit is kg
export const Mass: BaseQuantity = {
  id: "001mass",
  name: "mass",
  type: "numeric",
  value: "",
  symbol: "m",
  baseUnit: "kg",
  selectedUnit: "kg",
  units: [
    { name: "kg", fromConst: 1, toConst: 1 },
    { name: "g", fromConst: 1 / 10 ** 3, toConst: 10 ** 3 },
    { name: "mg", fromConst: 1 / 10 ** 6, toConst: 10 ** 6 },
    { name: "t", fromConst: 10 ** 3, toConst: 1 / 10 ** 3 },
    { name: "oz", fromConst: 1 / 35.27396, toConst: 35.27396 },
    { name: "lb", fromConst: 1 / 2.204623, toConst: 2.204623 },
    { name: "stone", fromConst: 1 / 0.157473, toConst: 0.157473 },
    { name: "gr", fromConst: 1 / 15432.36, toConst: 15432.36 },
  ],
};
